module.exports = __webpack_public_path__ + "img/icons/comments-avatar-placeholder-ad20a7c4f0d515a74b4147a61bf5f43f.svg";